import React from 'react';
import Moment from 'moment';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloseIcon from '@material-ui/icons/Close';
import DateFnsUtils from '@date-io/moment';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Snackbar from '@material-ui/core/Snackbar';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';

export default class Coupon extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            id: props.id,
            loading: false,
            coupon: "",
            code: "",
            discountValue: 0,
            discountType: 1,
            expirationDate: "",
            status: 0,
            openSnackbar: false,
            snackbarMessage: "",
        };
        this.onChangeCode = this.onChangeCode.bind(this);
        this.onChangeDiscountValue = this.onChangeDiscountValue.bind(this);
        this.onChangeExpirationDate = this.onChangeExpirationDate.bind(this);
        this.onChangeExpirationTime = this.onChangeExpirationTime.bind(this);
        this.showSnackbar = this.showSnackbar.bind(this);
        this.handleRequestCloseSnackbar = this.handleRequestCloseSnackbar.bind(this);
    }

    componentDidMount() {
        this.fetchCoupon();
    }

    fetchCoupon = () => {

        this.setState({
            loading: true
        });

        this.props.fetchApi('get', `/coupons/${this.getIdFromPath(this.state)}`)
            .then((response) => {
                this.setState({
                    coupon: response.data.coupon[0],
                    code: response.data.coupon[0].code,
                    discountValue: response.data.coupon[0].discountValue,
                    discountType: response.data.coupon[0].discountType,
                    expirationDate: response.data.coupon[0].expirationDate,
                    status: response.data.coupon[0].status,
                    loading: false
                })
            }).catch(() => {
                this.showSnackbar('Erro ao recuperar cupon. Tente novamente.');
                this.setState({
                    loading: false
                })
            });
    }

    updateCoupon = () => {

        this.setState({
            loading: true
        });

        this.props.fetchApi('patch', `/coupons/${this.getIdFromPath(this.state)}`, {
            data: {
                type: "coupon",
                attributes: {
                    code: this.state.code,
                    discountType: Number(this.state.discountType),
                    discountValue: Number(this.state.discountValue),
                    expirationDate: Moment.utc(this.state.expirationDate).format(),
                    status: Number(this.state.status),
                }
            }
        },)
            .then((response) => {
                this.setState({
                    coupon: response.data.coupon[0],
                    code: response.data.coupon[0].code,
                    discountValue: response.data.coupon[0].discountValue,
                    discountType: response.data.coupon[0].discountType,
                    expirationDate: response.data.coupon[0].expirationDate,
                    status: response.data.coupon[0].status,
                    loading: false
                })
            }).catch(() => {
                this.showSnackbar('Erro ao Salvar cupon. Tente novamente.');
                this.setState({
                    loading: false
                })
            });
    }

    deleteCoupon = () => {

        this.setState({
            loading: true
        });

        this.props.fetchApi('delete', `/coupons/${this.getIdFromPath(this.state)}`)
            .then((_) => {
                this.showSnackbar('Cupon deletado com Sucesso.');
                setTimeout(() => this.props.popRoute(), 2000);
                
            }).catch(() => {
                this.showSnackbar('Erro ao deletar cupon. Tente novamente.');
                this.setState({
                    loading: false
                })
            });
    }

    getIdFromPath(state) {
        const pathSlplit = state.id.location.pathname.split("/");

        return pathSlplit[pathSlplit.length - 1];
    }

    onChangeCode(code) {
        this.onChangeField("code", code);
    }

    onChangeDiscountValue(value) {
        this.onChangeField("discountValue", value);
    }

    onChangeExpirationDate(value, selectedDate) {
        let selected = Moment(selectedDate);
        const input = Moment(value);
        input.hour(selected.hour());
        input.minutes(selected.minutes());
        this.onChangeField("expirationDate", Moment.utc(input).format());
    }

    onChangeExpirationTime(value, selectedDate) {
        let selected = Moment(selectedDate);
        const input = Moment(value);
        selected.hour(input.hour());
        selected.minutes(input.minutes());
        this.onChangeField("expirationDate", Moment.utc(selected).format());
    }

    onChangeField(field, value) {
        this.setState({
            [field]: value
        });
    }

    isFormNotDirty(state) {
        const coupon = state.coupon;
        const {
            code,
            discountValue,
            discountType,
            expirationDate,
            status
        } = state;

        return coupon.code === code && String(coupon.discountValue) === String(discountValue) && String(coupon.discountType) === String(discountType) && Moment(coupon.expirationDate).utc().format() === Moment(expirationDate).utc().format() && String(coupon.status) === String(status);
    }

    showSnackbar(message) {
		this.setState({
			openSnackbar: true,
			snackbarMessage: message
		});
	}

	handleRequestCloseSnackbar() {
		this.setState({
			openSnackbar: false
		});
	}

    render() {
        const {
            loading,
            coupon,
            code,
            discountValue,
            discountType,
            expirationDate,
            status,
            snackbarMessage,
            openSnackbar
        } = this.state;

        return (
            <div>
                <br />
                <br />
                <Card style={{ padding: '1rem' }}>
                    {loading ?
                        <CircularProgress style={{ marginLeft: '1rem' }} /> :
                        (
                            <div>
                                <CardHeader
                                    title={`Cupon - ${coupon.id}`}
                                />
                                <Typography color="textSecondary" gutterBottom>
                                    id
                                </Typography>
                                <Typography color="textPrimary" gutterBottom>
                                    {coupon.id}
                                </Typography>
                                <form>
                                    <label htmlFor="Código" style={{ display: 'block', color: '#BBBBBB' }}>
                                        Código
                                    </label>
                                    <TextField
                                        fullWidth
                                        error={''}
                                        helperText={''}
                                        value={code}
                                        onChange={event => this.onChangeCode(event.target.value.toUpperCase())}
                                    />
                                    <label htmlFor="Valor do desconto" style={{ display: 'block', color: '#BBBBBB' }}>
                                        Valor do desconto
                                    </label>
                                    <TextField
                                        fullWidth
                                        error={''}
                                        helperText={''}
                                        value={discountValue}
                                        onChange={event => this.onChangeDiscountValue(event.target.value.replace(/\D/g, ''))}
                                    />
                                    <label htmlFor="Tipo de desconto" style={{ display: 'block', color: '#BBBBBB' }}>
                                        Tipo de desconto
                                    </label>
                                    <Select
                                        label="Tipo de desconto"
                                        value={discountType}
                                        onChange={(event) => this.onChangeField('discountType', event.target.value)}
                                    >
                                        <MenuItem value="1">
                                            VALOR
                                        </MenuItem>
                                        <MenuItem value="2">
                                            PORCENTAGEM
                                        </MenuItem>
                                    </Select>
                                    <label htmlFor="Data de expiração" style={{ display: 'block', color: '#BBBBBB' }}>
                                        Data de expiração
                                    </label>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                clearable
                                                label="Data"
                                                value={expirationDate}
                                                onChange={value => this.onChangeExpirationDate(value, expirationDate)}
                                                format="D/MM/YYYY"
                                                style={{ marginLeft: '10px' }}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'escolha a data',
                                                }}
                                            />
                                            <KeyboardTimePicker
                                                clearable
                                                label="Hora"
                                                value={expirationDate}
                                                onChange={value => this.onChangeExpirationTime(value, expirationDate)}
                                                style={{ marginLeft: '10px' }}
                                                ampm={false}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <label htmlFor="Status" style={{ display: 'block', color: '#BBBBBB' }}>
                                        Status
                                    </label>
                                    <Select
                                        label="Status"
                                        value={status}
                                        onChange={(event) => this.onChangeField('status', event.target.value)}
                                    >
                                        <MenuItem value="0">
                                            INATIVO
                                        </MenuItem>
                                        <MenuItem value="1">
                                            ATIVO
                                        </MenuItem>
                                    </Select>
                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={this.isFormNotDirty(this.state)}
                                            onClick={() => this.updateCoupon()}
                                        >
                                            Salvar
                                        </Button>
                                        <Button
                                            variant="contained"
                                            style={{ marginLeft: '10px' }} onClick={() => this.deleteCoupon()}>
                                            Deletar
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        )
                    }
                    <br />
                </Card>
                <Snackbar
					open={openSnackbar}
					message={snackbarMessage}
					onClose={this.handleRequestCloseSnackbar}
					autoHideDuration={3000}
					action={
						<IconButton
							color="inherit"
							onClick={this.handleRequestCloseSnackbar}
						>
							<CloseIcon />
						</IconButton>
					}
				/>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/Coupon.js